import { cloneDeep } from 'lodash/lang'
import { removeRedeemablePass } from 'lib/cart/services/selection'

const removeGuestPass = (state, action) => {
  const { camper, redeemablePass } = action

  // clone cart products so we don't mutate state
  const cartForm = cloneDeep(state)

  // add or update a cart product for this pass
  removeRedeemablePass(redeemablePass, {
    camper,
    cartForm
  })

  // return a new state object
  return Object.assign({}, state, cartForm)
}

export default removeGuestPass
